import { colors } from '../../shared/styles/baseStyle';

export const headerLayout = {
  minHeight: '100vh',
  backgroundColor: colors.bgGrey
};
export const layoutRow = { minHeight: 'calc(100vh - 64px)' };
export const headerStyle = {
  backgroundColor: '#fff',
  position: 'fixed',
  width: '100%',
  zIndex: 9999,
  top: 0,
  boxShadow: '0 1px 4px rgba(0,0,0,0.08)'
};
export const spaceStyle = { width: '100%', maxWidth: 580 };
export const title = { fontWeight: 700, color: 'black', marginBottom: 20 };
export const checkboxStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 18,
  height: 18,
  borderRadius: '50%',
  backgroundColor: colors.anytimeGreen,
  opacity: '40%'
};
export const content = { paddingTop: 64 };
export const subTitle = { fontSize: 14, color: 'black' };
export const checkOutline = { color: 'black', fontSize: 10 };
export const alertIcon = { color: colors.anytimeViolet };
export const alertText = { fontSize: 13 };
export const alert = {
  borderRadius: 8,
  backgroundColor: 'white',
  border: '1px solid #9C9C9C',
  marginTop: 20,
  marginBottom: 10
};
export const checkboxText = { fontSize: 14, color: 'black' };
export const applicationsSpace = {
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: 1
};
export const applicationsButton = {
  background: 'black',
  color: 'white',
  border: 'none',
  borderRadius: 8,
  fontWeight: 600
};
export const androidIcon = {
  width: 20,
  height: 20,
  color: 'white',
  marginRight: 6
};
export const rightColPadding = { paddingBottom: 40 };
